export const EMPTY_REPORT_TRACKER = Object.freeze({
    times: new Map(),
});
/**
 * Nimmt eine Sammelmeldung auf und schreibt fort, wann jedes Fahrzeug zuletzt
 * etwas gemeldet hat — gerechnet aus dem Alter, das der Server mitschickt.
 *
 * Fahrzeuge, die nicht mehr vorkommen, fallen heraus — sonst wüchse der Merker
 * über eine lange Ausfahrt mit jedem, der die Kolonne einmal verlassen hat.
 *
 * `previous` wird nicht mehr gebraucht: Jede Sammelmeldung trägt die Auskunft
 * vollständig bei sich. Der Parameter bleibt, damit die aufrufende Stelle
 * unverändert bleibt und ein späteres Fortschreiben wieder Platz hätte.
 */
export function trackReports(_previous, vehicles, seenAt) {
    const times = new Map();
    for (const fahrzeug of vehicles) {
        if (fahrzeug.reportAgeS === null) {
            continue;
        }
        times.set(fahrzeug.participantId, seenAt - fahrzeug.reportAgeS * 1000);
    }
    return { times };
}
//# sourceMappingURL=reports.js.map